import React, { Component } from 'react';

import Organization from '../organization/Organization';
import CustomMap from '../map/Map';
import Contacts from '../contacts/Contacts';
import './style.css';


export default class Footer extends Component {
  render() {
    return (
      <div className='footer'>
        <Organization/>
        <CustomMap/>
        <Contacts/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout-page/blocks/footer/Footer.js